export const FadeInAndOutDuration = 250; // duration is milliseconds

export const POPUP_TYPE = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};

export const HeadingColor = new Map([
  [POPUP_TYPE.INFO, ''],
  [POPUP_TYPE.ERROR, 'color-error'],
  [POPUP_TYPE.SUCCESS, 'color-primary-v2'],
]);
